<!-- src/components/ViewColeta.vue -->
<template>
  <div class="full-screen-background">
    <v-container class="text-center">
      <h2 class="text-h4 font-weight-bold my-4">
        {{ $t('daily.title') }}
      </h2>
      <p class="subtitle-1 mb-6">
        {{ $t('daily.subtitle') }}
      </p>

      <div class="images-row my-4">
        <v-card
          outlined
          class="item-card d-flex align-center justify-center listOpacity"
        >
          <div class="d-flex flex-column align-center">
            <span class="text-h5 font-weight-medium">
              {{ baseDescription }}
            </span>
            <div class="d-flex align-center mt-2">
              <img
                :src="barroImage"
                :alt="$t('daily.alchemyMudAlt')"
                class="barro-img"
              />
              <span class="text-h5 font-weight-medium ml-2">
                {{ quantity }}
              </span>
            </div>
          </div>
        </v-card>
      </div>

      <v-btn
        color="#5c3e62"
        dark
        :loading="isLoading"
        :disabled="redeemed || isLoading"
        @click="redeem"
      >
        <span v-if="!isLoading">
          {{ redeemed ? $t('daily.redeemed') : $t('daily.rescue') }}
        </span>
      </v-btn>

      <div v-if="redeemed && !showModal" class="mt-4 text-subtitle-1 font-weight-medium">
        {{ alreadyRedeemed
           ? $t('daily.alreadyRedeemed')
           : $t('daily.success') }}
      </div>

      <!-- Modal de sucesso -->
      <v-dialog v-model="showModal" max-width="400px">
        <v-card>
          <v-card-title class="headline">
            {{ $t('daily.success') }}
          </v-card-title>
          <v-card-text>
            {{ $t('daily.successMessage') || $t('daily.success') }}
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn text @click="closeModal">
              {{ $t('daily.close') || 'OK' }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </div>
</template>

<script>
import { defineComponent, ref } from 'vue'
import { redeemDaily, fetchRedeemStatus } from '@/services/api'
import barroImage from '@/assets/barro.png'

export default defineComponent({
  name: 'ViewColeta',
  props: {
    itemId: { type: Number, default: 48906 }
  },
  setup(props) {
    const redeemed = ref(false)
    const alreadyRedeemed = ref(false)
    const baseDescription = ref('')
    const quantity = ref('')
    const isLoading = ref(false)
    const showModal = ref(false)

    function fetchItemDescription() {
      const iniData = `
        1663|Poder do Demonio|$7$Tem algo estranho com esse tonico...
        $12$Uso: Pode ter um efeito inesperado.
        48906|Espada Luminosa|$7$barro de alquimia magico x5
        $12$Uso: Ideal para batalhas contra criaturas das sombras.
      `
      for (const line of iniData.split('\n')) {
        const parts = line.split('|')
        if (parseInt(parts[0]) === props.itemId) {
          const full = parts[2].replace('$7$', '').trim()
          const lastSpace = full.lastIndexOf(' ')
          baseDescription.value = full.slice(0, lastSpace)
          quantity.value = full.slice(lastSpace + 1)
          break
        }
      }
    }

    async function checkRedeemStatus() {
      try {
        const token = localStorage.getItem('jwt_token')
        const { redeemed: was } = await fetchRedeemStatus(token)
        if (was) {
          redeemed.value = true
          alreadyRedeemed.value = true
        }
      } catch (err) {
        console.error('Erro ao verificar status de resgate:', err)
      }
    }

    async function redeem() {
      if (redeemed.value) return
      isLoading.value = true
      try {
        const token = localStorage.getItem('jwt_token')
        const resp = await redeemDaily(token, props.itemId)
        // supondo que `resp.ok` === true
        if (resp.ok) {
          redeemed.value = true
          showModal.value = true
        }
      } catch (err) {
        console.error('Erro no resgate diário:', err)
      } finally {
        isLoading.value = false
      }
    }

    function closeModal() {
      showModal.value = false
    }

    fetchItemDescription()
    checkRedeemStatus()

    return {
      redeemed,
      alreadyRedeemed,
      baseDescription,
      quantity,
      barroImage,
      isLoading,
      showModal,
      redeem,
      closeModal
    }
  }
})
</script>

<style scoped>
.item-card { width: 250px; height: 250px; }
.images-row { display: flex; align-items: center; justify-content: center; }
.barro-img { width: 40px; height: 40px; object-fit: contain; }
.listOpacity {
  background-color: rgba(0, 0, 0, 0.459);
  padding: 1rem;
  border-radius: 0.5rem;
}
.full-screen-background {
  background-image: url('@/assets/background/fundotrocasenha.png');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  min-height: 100vh;
  width: 100%;
  position: relative;
}
</style>
